<div (click)="sendClose()" class="absolute left-0 top-0 opacity-30 h-full w-screen bg-black"></div>

<div class="absolute max-lg:left-0 lg:w-[500px] lg:right-0 top-0 bg-white h-full overflow-scroll w-full">
  <div class="fixed max-lg:w-full lg:w-[500px]" #stickyHeaderHeader>
    <ng-content select="[header]"></ng-content>
  </div>
  <div #stickyHeaderAddHeaderHeight></div>
  <div #stickyHeaderMain><ng-content select="[main]"></ng-content></div>
</div>
